import React from 'react'
import Dropdown from '@groovehq/internal-design-system/lib/components/Dropdown/Dropdown'
import Button from '@groovehq/internal-design-system/lib/components/Button/Button'
import styles from './styles.less'
import PresenceButtonLabel from './Label'
import PresenceDropdown from '../Dropdown'

export default function PresenceButton({
  onSettingChange,
  onPresenceChange,
  autoAwaySetting,
  autoOfflineSetting,
  autoPresenceSetting,
  presence,
}) {
  return (
    <>
      <Dropdown
        position="top-start"
        strategy="fixed"
        autoHeight
        overlay={
          <PresenceDropdown
            onSettingChange={onSettingChange}
            onPresenceChange={onPresenceChange}
            autoAwaySetting={autoAwaySetting}
            autoOfflineSetting={autoOfflineSetting}
            autoPresenceSetting={autoPresenceSetting}
            presence={presence}
          />
        }
      >
        <Button type="tertiary" size="small" className={styles.button}>
          Profile status: <PresenceButtonLabel presence={presence} />
        </Button>
      </Dropdown>
    </>
  )
}
